import instance from 'utils/axios/instance.axios';
import { SPECIALIZE_REVIEW } from './_constant';

export const getGeneralProjectProposalInfo = (councilId, projectProposalId) =>
  instance.get(SPECIALIZE_REVIEW.GET_PROJECT_PROPOSAL_INFO, {
    params: { councilId, projectProposalId },
  });

export const getReviewerInfo = (userId, councilId, projectProposalId) =>
  instance.get(SPECIALIZE_REVIEW.GET_REVIEWER_INFO, {
    params: { userId, councilId, projectProposalId },
  });

export const getDetail = (councilMemberId, councilId, projectProposalId) =>
  instance.get(SPECIALIZE_REVIEW.GET_DETAIL, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const create = (data = {}) => instance.post(SPECIALIZE_REVIEW.CREATE, data);

export const update = (data = {}) => instance.patch(SPECIALIZE_REVIEW.UPDATE, data);

export const submit = (data = {}) => instance.post(SPECIALIZE_REVIEW.SUBMIT, data);

// Review file

export const getDetailFile = (councilMemberId, councilId, projectProposalId) =>
  instance.get(SPECIALIZE_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const uploadDetailFile = (body = {}) =>
  instance.post(SPECIALIZE_REVIEW.UPLOAD_DETAIL_FILE, body);

export const updateDetailFile = (body = {}) =>
  instance.patch(SPECIALIZE_REVIEW.UPDATE_DETAIL_FILE, body);

export const downloadDetailFile = (body = {}) =>
  instance.post(SPECIALIZE_REVIEW.DOWNLOAD_DETAIL_FILE, body, { responseType: 'blob' });

export const submitDetailFile = (body = {}) =>
  instance.patch(SPECIALIZE_REVIEW.SUBMIT_DETAIL_FILE, body);

export const downloadPdfFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    SPECIALIZE_REVIEW.DOWNLOAD_PDF_FILE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
export const downloadPdfTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    SPECIALIZE_REVIEW.DOWNLOAD_PDF_TEMPLATE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    SPECIALIZE_REVIEW.DOWNLOAD_DOCX_FILE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
export const downloadDocxTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    SPECIALIZE_REVIEW.DOWNLOAD_DOCX_TEMPLATE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
